<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title dense class="grey lighten-1 mb-2 white--text">
        Trail Balance
        <v-spacer></v-spacer>
        <v-text-field
          outlined
          v-model="search"
          append-icon="fas fa-search"
          label="Search"
          single-line
          hide-details
          class="d-print-none"
        ></v-text-field>
      </v-card-title>
      <v-card-text>
        <v-data-table
          :hide-default-footer="hideFooter"
          flat
          :headers="headers"
          :items="sales"
          :search="search"
        >
          <template v-slot:item.in="{ item }">
            <div v-if="item.Acc == 'Dr'">
              {{ item && item.Amount && item.Amount.toLocaleString() }}
              {{ item.AmountType | MoneySigns }}
            </div>
          </template>
          <template v-slot:item.out="{ item }">
            <div v-if="item.Acc == 'Cr'">
              {{ item && item.Amount && item.Amount.toLocaleString() }}
              {{ item.AmountType | MoneySigns }}
            </div>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
// import axios from "axios";
export default {
  components: {
    // cashDisplay: () => import("@/components/coman/cashView"),
    // searchDate: () => import("@/components/util/searchDate.vue")
  },
  data() {
    return {
      SalesRepo: "/Reports/statement",
      searching: false,
      isloading: false,
      hideFooter: false,
      search: "",
      fromDate: "",
      toDate: "",
      sales: [],
      TotalBalance: [],
      headers: [
        {
          text: "Account",
          align: "left",
          value: "MainAccount",
          class: "teal darnken-2 white--text",
        },
        {
          text: "Details",
          value: "category",
          class: "teal darnken-2 white--text",
        },
        {
          text: "Description",
          value: "AccountName",
          class: "teal darnken-2 white--text",
        },

        { text: "Dr", value: "in", class: "teal darnken-2 white--text" },
        { text: "Cr", value: "out", class: "teal darnken-2 white--text" },
        // { text: "Details", value: "Details" },
        // // { text: "Dr/Cr", value: "Acc" },
        // { text: "User", value: "User" },
        // { text: "Ref", value: "Ref" }
      ],
    };
  },
  computed: {},
  methods: {
    GetReq(url) {
      if (!url) url = this.SalesRepo;

      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query: {},
      });
    },
    loadSales() {
      try {
        this.searching = true;
        this.isloading = true;

        this.GetReq()
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value.data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    this.loadSales();
  },
};
</script>
